// Function to check if ESPN token is about to expire or has expired
export const isEspnTokenExpiring = (userDataPlatform: any): boolean => {
    if (!userDataPlatform || userDataPlatform.integration_name !== "espn") {
      return false;
    }
  
    const tokenExpiresAt = userDataPlatform.token_expires_at;
  
    // If there's no expiration data, it's safer to assume it's invalid/expired.
    if (!tokenExpiresAt) {
      console.warn("⚠️ ESPN token is missing expiration data. Assuming it has expired.");
      return true;
    }
  
    const now = Date.now();
    // We check if the token will expire in the next 5 minutes.
    const isExpiringSoon = now >= tokenExpiresAt;
  
    // if the token is expiring soon, log the time remaining
    if (isExpiringSoon) {
      const timeRemainingMs = tokenExpiresAt - now;
      const timeRemainingMin = Math.floor(timeRemainingMs / 60000);
  
      console.log("🔴 ESPN Token Expiration Check:", {
        status: "Token is expiring soon or has expired.",
        expiresAt: new Date(tokenExpiresAt).toLocaleString(),
        currentTime: new Date(now).toLocaleString(),
        timeRemainingMinutes: timeRemainingMin,
      });
    }
  
    return isExpiringSoon;
  };